/**
 * Check to see if views should be enabled (and adjusting view if needed)
 * @param  {Object} router          router state
 * @param  {Object} [data={}]       default global state
 * @param  {Object} [verify={} }]   verficiation state
 * @return {Object}                 state object
 */
export default function viewsEnabled(state) {
  const { verify = {} } = state.data;
  verify.viewsEnabled = ['0'];

  const {
    view = '0',
    indicators = [],
    geos = [],
  } = state.router;
  const { selectedCategories = [] } = state.data;
  if (0 < selectedCategories.length || (indicators.length)) {
    verify.viewsEnabled.push('1');
  }
  if (indicators && indicators.length) {
    verify.viewsEnabled.push('2');
  }
  if ((indicators && indicators.length) && geos.length) {
    verify.viewsEnabled.push('3');
  }

  // If we are a view that is disabled, we need to move to one that isn't
  if (-1 === verify.viewsEnabled.indexOf(view)) {
    // eslint-disable-next-line no-param-reassign
    state.router.view = verify.viewsEnabled.reduce(
      (a, x) => (a < x ? x : a),
      '0'
    );
  }

  return {
    ...state,
    router: { ...state.router },
    data: { ...state.data, verify },
  };
}



// WEBPACK FOOTER //
// ./app/services/verification/viewsEnabled.js